/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

export class Elements {
  public getSubmitButton(): HTMLButtonElement {
    return document.getElementById('okta-signin-submit') as HTMLButtonElement;
  }

  public getContainer(): HTMLElement {
    // div in which the widget places itself
    return document.getElementById('widget-container');
  }

  public getFieldsetFromDescendent(descendent: HTMLElement, optionalSubSelector: string): HTMLElement {
    const fieldset = descendent.closest('.o-form-fieldset') as HTMLElement;
    return optionalSubSelector && fieldset ? fieldset.querySelector<HTMLElement>(optionalSubSelector) : fieldset;
  }

  public getFieldsetContainer(): HTMLElement {
    // widget's container of form fields
    // field is in the form, which means there will be 2 when transitioning, so always grab the last one
    return document.querySelector('#okta-sign-in.auth-container .auth-content-inner > div:last-of-type .o-form-fieldset-container') as HTMLElement;
  }
}
